// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__MuEEO","layoutFixed":"Table_layoutFixed__rLxUy","table":"Table_table__LQlzF","withBorders":"Table_withBorders__6_YRm","td":"Table_td__FOfSp"};